import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from "@angular/common/http";
import {PriceRobotRule} from "./price-robot-rule";
import {environment} from "../../environments/environment";
import {AuthService, BaseService} from "@hassel-it/angular-common";

@Injectable({
    providedIn: 'root'
})
export class PriceRobotRulesService extends BaseService {

    constructor(public http: HttpClient, public authService: AuthService) {
        super(http, authService);
    }

    index(query?: RulesQuery) {
        this.reloadHeaders();

        let myParams = new HttpParams();

        if (query && query.forProductId) {
            myParams = myParams.append('forProductId', query.forProductId);
        }

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/rules', {
            params: myParams,
            headers: this.httpHeaders
        })
    }

    view(id: number) {
        this.reloadHeaders();

        return this.http.get(environment.apiBase + '/api/tenfour-crawler/rules/' + id, {headers: this.httpHeaders})
    }

    edit(rule: PriceRobotRule) {
        this.reloadHeaders();

        return this.http.put(environment.apiBase + '/api/tenfour-crawler/rules/' + rule.id, rule, {headers: this.httpHeaders})
    }

    editMany(rules: PriceRobotRule[]) {
        this.reloadHeaders();

        return this.http.patch(environment.apiBase + '/api/tenfour-crawler/rules/edit-many', rules, {headers: this.httpHeaders});
    }

    add(rule: PriceRobotRule) {
        this.reloadHeaders();

        return this.http.post(environment.apiBase + '/api/tenfour-crawler/rules', rule, {headers: this.httpHeaders})
    }

    delete(rule: PriceRobotRule) {
        this.reloadHeaders();

        return this.http.delete(environment.apiBase + '/api/tenfour-crawler/rules/' + rule.id, {headers: this.httpHeaders})
    }

    duplicate(rule: PriceRobotRule, name: string) {
        this.reloadHeaders();

        return this.http.post(environment.apiBase + '/api/tenfour-crawler/rules/copy/' + rule.id, {name: name}, {headers: this.httpHeaders})
    }
}


export interface RulesQuery {
    forProductId?: number;
}
